import { render, staticRenderFns } from "./SerpTracker.vue?vue&type=template&id=24676a77&scoped=true"
import script from "./SerpTracker.vue?vue&type=script&lang=js"
export * from "./SerpTracker.vue?vue&type=script&lang=js"
import style0 from "./SerpTracker.vue?vue&type=style&index=0&id=24676a77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24676a77",
  null
  
)

export default component.exports